import * as yup from 'yup';

const termsValidationSchema = yup.object().shape({
  title: yup.string().required('Title is Required'),
  description: yup.string().required('Description is Required'),
});

export default termsValidationSchema;
